<template>
    <div>
        <label>
          <!-- Decor Image needs to by 2048x2048 -->
            <input type="radio" name="decor" class="decor" :value="id" @change="$emit('input', $event.target.value)" />
            <img :src="'img/' + id + '.jpg'">
        </label>
    </div>
</template>

<script>
export default {
  props: {
    id: String,
    core: String
  }
}
</script>

<style lang="scss">

</style>
